/**
 * お問い合わせページに表示する期間限定お知らせの設定
 */
import isWithinRange from "date-fns/is_within_range";

export interface ContactNotice {
  /** i18n キー: `contact.notices.*.title` */
  titleKey: string;
  /** i18n キー: `contact.notices.*.message` */
  messageKey: string;
  startAt: Date;
  endAt: Date;
}

/**
 * 年末年始お知らせ設定
 *
 * NOTE: `endAt` は JST 2026-01-07 23:59 で経過済み。
 * 現在は `getActiveContactNotice()` からは参照されていないが、
 * 過去事例のリファレンスとして残置している（完全削除は別 PR で検討）。
 */
export const yearEndNotice: ContactNotice = {
  titleKey: "contact.notices.yearEnd.title",
  messageKey: "contact.notices.yearEnd.message",
  startAt: new Date("2025-12-10T00:00:00+09:00"),
  endAt: new Date("2026-01-07T23:59:59+09:00"),
};

/**
 * GW（ゴールデンウィーク）お知らせ設定
 */
export const goldenWeekNotice: ContactNotice = {
  titleKey: "contact.notices.goldenWeek.title",
  messageKey: "contact.notices.goldenWeek.message",
  startAt: new Date("2026-04-21T00:00:00+09:00"),
  endAt: new Date("2026-05-10T23:59:59+09:00"),
};

/**
 * 現在表示すべきお知らせを取得する
 */
export const getActiveContactNotice = (): ContactNotice | null => {
  const now = new Date();

  if (isWithinRange(now, goldenWeekNotice.startAt, goldenWeekNotice.endAt)) {
    return goldenWeekNotice;
  }

  return null;
};
